import type { z } from "zod";

import { ImpulseFormList, ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

import { type DashboardStaticListVariable, dashboardStaticListVariableSchema } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";

const valueSchema = dashboardStaticListVariableSchema.shape.values
	.removeCatch()
	.sourceType()
	.element.removeCatch()
	.unwrap();

export type StaticValueState = ImpulseFormShape<{
	id: string;
	value: ImpulseFormUnit<string, ReadonlyArray<string>>;
	label: ImpulseFormUnit<string, ReadonlyArray<string>, undefined | string>;
}>;

export function initStaticValueState(id: string, value?: z.infer<typeof valueSchema>): StaticValueState {
	return ImpulseFormShape({
		id,
		value: ImpulseFormUnit(value?.value ?? "", {
			isInputDirty: isStringDirty,
			schema: valueSchema.shape.value,
		}),
		label: ImpulseFormUnit(value?.label ?? "", {
			isInputDirty: isStringDirty,
			schema: valueSchema.shape.label.removeCatch(),
		}),
	});
}

export type FormState = ImpulseFormList<StaticValueState>;

export const Processor: FormProcessor<FormState, undefined | DashboardStaticListVariable> = {
	fromSpec: (spec) => {
		const values = spec?.values.length ? spec.values : [{ value: "" }];

		return ImpulseFormList(values.map((value, index) => initStaticValueState(index.toString(), value)));
	},

	toSpec: (values) => ({
		values: values.map(({ value, label }) => ({ value, label })),
	}),
};
